module.exports = __webpack_public_path__ + "static/img/12.9e838c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/7/eng/12.png
// module id = +pA1
// module chunks = 0